// Domain configuration from environment variables
export const DOMAIN_WEB = process.env.NEXT_PUBLIC_DOMAIN_WEB as string;
export const DOMAIN_API = process.env.NEXT_PUBLIC_DOMAIN_API as string;
export const DOMAIN_HUB = process.env.NEXT_PUBLIC_DOMAIN_HUB as string;

export const URL_WEB = `https://${DOMAIN_WEB}`;
export const URL_API = `https://${DOMAIN_API}`;
export const URL_HUB = `https://${DOMAIN_HUB}`;

// Protocol-relative URL for links (//domain)
export const HUB_URL_RELATIVE = `//${DOMAIN_HUB}`;

// Hub paths
export const HUB_APP_PATH = "/s";
export const HUB_APP_URL = `${URL_HUB}${HUB_APP_PATH}`;

export const getHubPath = (sessionUid?: string) =>
  `${HUB_APP_PATH}${sessionUid ? `/${sessionUid}` : ""}`;

export const getHubUrl = (sessionUid?: string) =>
  `${URL_HUB}${getHubPath(sessionUid)}`;
